<template>
  <div class="font-display min-h-screen relative overflow-hidden bg-white">
    <!-- 科技网格叠加层（保留但降低透明度） -->
    <div class="fixed inset-0 pointer-events-none z-0">
      <!-- 网格图案 -->
      <div
        class="absolute inset-0 opacity-5"
        style="
          background-image:
            linear-gradient(rgba(0, 242, 255, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 242, 255, 0.3) 1px, transparent 1px);
          background-size: 50px 50px;
        "
      ></div>
    </div>

    <!-- 内容 -->
    <div class="relative z-10">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
// 浅色主题 + 赛博朋克交互效果
</script>
